import { useState, useEffect } from 'react'

import { UserRole, useUser } from '../user'

const useAccess = (allowedRoles?: UserRole[]) => {
  const { currentUser } = useUser()

  const [hasAccess, setHasAccess] = useState<null | boolean>(null)

  const role = currentUser?.role

  useEffect(() => {
    setHasAccess(() => (allowedRoles ? allowedRoles?.includes(role as UserRole) : true))
  }, [allowedRoles, role])

  return hasAccess
}

export default useAccess
